module.exports = __webpack_public_path__ + "img/color-1@2x.e8828ac.webp";